import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// DELETE: Deletes a comment from a form instance
async function httpDeleteCommentFromFormInstance(instanceId, commentId) {
  const token = Auth.getToken();
  try {
    let response = await fetch(
      `${API_URL}/companies/comments/${instanceId}/${commentId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await response.json();
  } catch (err) {
    return err;
  }
}

// DELETE: Deletes a manual by ID
async function httpDeleteManual(manualId) {
  const token = Auth.getToken();
  try {
    let response = await fetch(`${API_URL}/companies/manuals/${manualId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await response.json();
  } catch (err) {
    return err;
  }
}

// DELETE: Deletes a form instance by ID
async function httpDeleteFormInstance(instanceId) {
  const token = Auth.getToken();
  try {
    let response = await fetch(`${API_URL}/companies/forms/instance`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ instanceId }),
    });
    return await response.json();
  } catch (err) {
    return err;
  }
}

export {
  httpDeleteCommentFromFormInstance,
  httpDeleteManual,
  httpDeleteFormInstance,
};
